import { combineReducers } from 'redux';
import context, { contextInitialState } from './context/reducer';
import entities, { entitiesInitialState } from './entities/reducer';
import ui, { uiInitialState } from './ui/reducer';

export const initialRootState = {
	entities: entitiesInitialState,
	context: contextInitialState,
	ui: uiInitialState,
} as const;

export default combineReducers({
	context,
	ui,
	entities,
});
